import React from "react"

export default function({
  grandTotal,
  currency,
  paymentDetail,
  paymentStatus,
  refundAmount
}) {
  const hasVerified =
    (paymentDetail &&
      paymentDetail.image &&
      paymentDetail.image.length > 0 &&
      paymentDetail.image[0].is_verified) ||
    false
  const initial = hasVerified
    ? (paymentDetail.image[0] && paymentDetail.image[0].amount) || 0
    : 0
  const pending = hasVerified ? parseFloat(grandTotal) - parseFloat(initial) : 0
  const final =
    (paymentDetail &&
      paymentDetail.image &&
      paymentDetail.image.length > 1 &&
      paymentDetail.image[1].amount) ||
    0
  const oneTimePayment =
    paymentStatus === "paid" &&
    ((paymentDetail &&
      paymentDetail.image &&
      paymentDetail.image.length <= 1) ||
      false)
  return (
    <div className="grand-total">
      <div className="total space-between">
        <span className="bold">Total</span>
        <span>
          <span>
            {parseFloat(grandTotal).toLocaleString("en", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            })}
          </span>
          <span> {currency}</span>
        </span>
      </div>
      {!oneTimePayment && (
        <>
          {initial > 0 && (
            <>
              {parseFloat(grandTotal).toLocaleString("en", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              }) !==
                parseFloat(initial).toLocaleString("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }) && (
                <div
                  className={`total space-between ${
                    paymentStatus === "refunded" ? "" : "border-bottom"
                  } initial`}
                >
                  <span className="bold">Initial Payment</span>
                  <span>
                    <span>
                      {parseFloat(initial).toLocaleString("en", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                      })}
                    </span>
                    <span> {currency}</span>
                  </span>
                </div>
              )}
              {paymentStatus === "refunded" && (
                <div className="total space-between border-bottom initial">
                  <span className="bold">Total Refund Amount</span>
                  <span>
                    <span>
                      {parseFloat(refundAmount).toLocaleString("en", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                      })}
                    </span>
                    <span> {currency}</span>
                  </span>
                </div>
              )}
            </>
          )}
          {paymentStatus === "partial" && (
            <div className="total space-between pending">
              <span className="bold">Pending Amount</span>
              <span>
                <span>
                  {parseFloat(pending).toLocaleString("en", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                  })}
                </span>
                <span> {currency}</span>
              </span>
            </div>
          )}
          {paymentStatus === "paid" && (
            <div className="total space-between final">
              <span className="bold">Final Payment</span>
              <span>
                <span>
                  {parseFloat(final).toLocaleString("en", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                  })}
                </span>
                <span> {currency}</span>
              </span>
            </div>
          )}
        </>
      )}
    </div>
  )
}
